import {IEnvironment} from './interface';

export default {
  api: process.env.REACT_APP_API_ENDPOINT!,
} as IEnvironment;
